<template>
  <section class="bg-[--white2] flex flex-col w-full items-center">
    <div
      class="flex flex-col gap-[40px] w-full xl:w-[1280px] py-[41px] px-[32px] lg:px-[100px] items-center xl:pb-[86px] xl:px-0">
      <div class="section-header-container">
        <h4 class="section-header-1">Diferenciais Vip</h4>
        <h3 class="section-header-2">Vantagens Exclusivas</h3>
      </div>

      <ul
        class="grid w-full grid-cols-[auto] gap-[9px] lg:w-[auto] lg:grid-cols-2 lg:gap-x-[20px] lg:gap-y-[15px] xl:grid-cols-4">
        <li v-for="(vantagem, index) in vantagens" :key="index"
          class="flex flex-col justify-center items-center h-[279px] p-[30px] pr-[20px] bg-[#F8F3F3] gap-[10px] lg:items-start lg:w-[319px] xl:w-[313px] xl:gap-x-[9px]">
          <img :src="vantagem.iconsrc" class="h-[68px] w-[68px] p-[15.5px] rounded-full bg-[--yellow] mb-[10px]" />
          <h3 class="text-[--black] heading-35" v-text="vantagem.title"></h3>
          <span class="text-20 lg:text-left" v-html="vantagem.text"></span>
        </li>
      </ul>

      <LinkButton customClass="!py-[12.5px] !px-[25px] !w-full !text-[20px] lg:!w-[288px]" :url="whatsappUrl"
        label="Quero antecipar" />

      <div class="section-header-container mt-[23px]">
        <h4 class="section-header-1">Antecipação Vip</h4>
        <h3 class="section-header-2">Por que antecipar meu FGTS?</h3>
      </div>

      <div class="flex flex-col w-full gap-[24px] lg:flex-row-reverse lg:items-center justify-center">
        <ul class="flex flex-col w-full items-center lg:w-fit gap-[9px] lg:gap-[11px]">
          <li v-for="(info, index) in infos" :key="index"
            class="flex flex-row justify-start items-center h-[159px] w-full max-w-[417px] bg-[#F8F3F3] gap-[19px] p-[15px] xs:py-[21px] xs:px-[29px] rounded-[7px]"
            :class="{ '!bg-[--yellow]': index === 0 }">
            <div
              class="hidden xs:flex w-[12px] h-full bg-[--yellow] rounded-tr-[1px] rounded-tl-[7px] rounded-bl-[1px] rounded-br-[7px] shrink-0"
              :class="{ '!bg-[#EBEBEB]': index === 0 }"></div>
            <div>
              <h3 class="text-[--black] heading-35" :class="{ '!text-[#EBEBEB]': index === 0 }" v-text="info.title">
              </h3>
              <span class="text-20" :class="{ '!text-[#EBEBEB]': index === 0 }" v-html="info.text"></span>
            </div>
          </li>
        </ul>
        <div class="flex lg:min-w-[381px] lg:max-w-[449px]">
          <img class="object-cover w-full" src="/img/imagem2.webp" alt="Banner" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import LinkButton from "../components/LinkButton.vue";
import { useWhatsappUrl } from "@/composables/useWhatsappUrl";

export default {
  name: "SectionValue",
  components: {
    LinkButton,
  },
  setup() {
    const { whatsappUrl } = useWhatsappUrl(
      "Olá, gostaria de simular minha antecipação do FGTS."
    );
    return { whatsappUrl };
  },
  data() {
    return {
      vantagens: [
        {
          title: "100%",
          text: "Aprovação <br/> para negativados.",
          iconsrc: "/img/icons/aprovacao-check.svg",
        },
        {
          title: "2 horas",
          text: "Para ter o seu <br/> dinheiro liberado.",
          iconsrc: "/img/icons/clock.svg",
        },
        {
          title: "Praticidade",
          text: "Aquisição do empréstimo <br/> feita 100% pelo celular.",
          iconsrc: "/img/icons/celular.svg",
        },
        {
          title: "Orçamento",
          text: "Não compromete o <br/> orçamento mensal.",
          iconsrc: "/img/icons/cash.svg",
        },
      ],
      infos: [
        {
          title: "Crédito com agilidade.",
          text: "Processo 100% digital, sem sair de casa.",
        },
        {
          title: "Use como quiser",
          text: "Pague dívidas, invista no seu negócio ou realize um sonho. ",
        },
        {
          title: "O dinheiro é seu!",
          text: "Você só está adiantando o que tem por direito.",
        },
      ],
    };
  },
};
</script>
